import { render, staticRenderFns } from "./ListenTranslation.vue?vue&type=template&id=46513592&scoped=true"
import script from "./ListenTranslation.vue?vue&type=script&lang=js"
export * from "./ListenTranslation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46513592",
  null
  
)

export default component.exports